import { makeStyles, fade } from '@material-ui/core/styles';

export const PaySupplierSideBarCss = makeStyles((theme) => ({
    transactionDetailsDrawer: {
        width: 538,
        maxWidth: 538,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    emptyStateDiv:{
      display:'flex',
      flexDirection:'column',
      alignItems:'center',
      justifyContent:'center'
    },
    emptyTxt:{
      color:"#787878",
      marginTop:32,
      textAlign:'center'
    },
    addCta:{
      backgroundColor:"#0033cc",
      textTransform:"uppercase",
      fontWeight:600,
      color:'#fff',
      paddingTop:17,
      paddingBottom:17,
      borderRadius:8,
      width:'100%',
      '&:hover':{
        backgroundColor:"#0033cc",
      }
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    divTitle: {
        display: 'flex',
        alignItems: 'center',
        color: "#0b1323",
        fontSize: 18,
        marginBottom: 4,
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal'
    },
    sideBarDialogContentV1: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 24,
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 20,
        backgroundColor: '#f6f6f8'
    },
    divTitleV1: {
        fontSize: 12,
        fontWeight: 300,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.5)'
    },
    divTitleV2: {
        fontSize: 12,
        fontWeight: 300,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: 'rgba(11, 19, 35, 0.5)'
    },
    divContainerBox: {
        padding: '16px 24px 16px 24px',
        borderRadius: 8,
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed',
        marginTop: 8
    },
    titleV2: {
        fontSize: 16,
        fontWeight: 300,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    divText: {
        fontSize: 16,
        fontWeight: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        marginTop: 4
    },
    divTextV1: {
        fontSize: 16,
        fontWeight: 'bold',
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 4
    },
    gridContainerV1: {
        padding: '16px 24px',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed'
    },
    dialogV1: {
        borderRadius: '8px !important'
    },
    dialogTitleV1: {
        paddingLeft: 30,
        paddingTop: 8,
        paddingBottom: '8px !important',
        paddingRight: 12
    },
    dialogActionsV1: {
        paddingTop: 20,
        paddingBottom: '20px !important',
        paddingRight: 30,
        paddingLeft: 30
    },
    closeButton: {
        borderRadius: '4px !important',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 6,
        paddingBottom: 6,
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: '#3e3f42',
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        }
    },
    widthV1: {
        maxWidth: '420px !important'
    },
    divAlignTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    closeIconV1: {
        color: '#D0D0D0',
        fontSize: 20
    },
    dialogContentV1: {
        paddingTop: 24,
        paddingBottom: '24px !important',
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: '#f6f6f8'
    },
    gridTitleDialog: {
        fontSize: '12px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.75)',
        paddingLeft: 8,
        paddingRight: 8,
        marginBottom: 8
    },
    gridContainerDialog: {
        padding: '16px !important',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed'
    },
    containerWidth: {
        width: 'fit-content'
    },
    containerWidthV1: {
        width: '180px'
    },
    gridRouteDialog: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: '#0b1323'
    },
    gridParamsDialog: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 2,
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
    },
    dotV2: {
        fontSize: '6px !important',
        color: '#c4c4c4',
        marginLeft: 4,
        marginRight: 6
    },
    textBalance: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323'
    },
    saveButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#09101e',
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        color: '#ffffff',
        textTransform: 'none',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        marginLeft: '16px !important',
        '&:hover': {
            backgroundColor: '#09101e'
        }
    },
    gridRoute: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        overflowWrap: 'break-word'
    },
    gridParam: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 4,
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)',
    },
    dotV1: {
        fontSize: 6,
        color: '#c4c4c4',
        marginLeft: 8,
        marginRight: 8
    },
    tripBalance: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323'
    },
    gridItemV1: {
        display: 'flex'
    },
    cardInput: {
        backgroundColor: 'white',
        marginLeft: '0.5em',
        width: 86,
        '& .MuiOutlinedInput-input': {
            paddingTop: 1,
            paddingBottom: 1,
            paddingRight: '3px !important'
        },
        '& .MuiOutlinedInput-adornedStart': {
            paddingLeft: '0px !important'
        }
    },
    marginV1: {
        marginLeft: 6,
        marginRight: 6
    },
    gridItemStatus: {
        marginTop: 4,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end'
    },
    divBox: {
        padding: '2px 4px',
        borderRadius: '2px',
        backgroundColor: '#c6d4ff',
        fontSize: '10px',
        color: '#0033cc',
        width: 'fit-content',
        letterSpacing: '0.05em',
        fontWeight: 'bold'
    },
    divBoxPart: {
        padding: '2px 4px',
        borderRadius: '2px',
        backgroundColor: '#ffdbc1',
        fontSize: '10px',
        color: '#e8843c',
        width: 'fit-content',
        letterSpacing: '0.05em',
        fontWeight: 'bold'
    },
    divAmountContainer: {
        marginTop: 24
    },
    titleV3: {
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    mtV4: {
        marginTop: 4
    },
    textFieldV1: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },
    mtV5: {
        marginTop: 24
    },
    errorV1: {
        fontSize: 16,
        color: '#ff1744',
        marginBottom: 8
    },
    checkBoxLabel: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.75)',
        marginBottom: 8
    },
    checkboxInput: {
        width: '100%'
    },
    checkBoxLabel: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.75)',
        marginBottom: 8
    },
    checkBoxChecked: {
        color: 'transparent !important'
    },
    checkboxTripLabel: {
        height: '100%',
        minHeight: 78,
        maxHeight: 100,
        backgroundColor: 'white',
        borderRadius: 8,
        marginLeft: 0,
        marginRight: 0,
        width: '100%',
        paddingTop: 16,
        paddingBottom: 16,
        paddingRight: 16,
        paddingLeft: 15,
        marginBottom: '12px',
        '& .MuiFormControlLabel-label': {
            width: '100%'
        }
    },
    divAlign: {
        display: 'flex',
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: '#0033cc'
    },
    divAlignV1: {
        display: 'flex',
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: '#e8843c'
    },
    dialogTitle: {
        paddingLeft: '30px !important',
        paddingRight: '18px !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important'
    },
    backButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        marginRight: 16,
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    payButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#09101e',
        color: 'white',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#09101e'
        }
    },
    payButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#dadada !important',
        color: '#5e636c !important',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#dadada !important'
        }
    },
    dialogActions: {
        paddingTop: '24px !important',
        paddingBottom: '24px !important',
        paddingRight: '30px !important',
        paddingLeft: '30px !important',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'normal'
    },
    divAlignActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    search: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: "#fff",
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        border: "solid 1px rgba(11, 19, 35, 0.5)",
        marginRight: 0,
        marginLeft: 0,
        width: '100%',
    },
    searchIcon: {
        padding: "0px 12px",
        height: '100%',
        color: "rgba(11, 19, 35, 0.75)",
        //position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    sicon: {
        fontSize: 18
    },
    closeIcon: {
        padding: "0px 12px",
        height: '100%',
        color: "rgba(11, 19, 35, 0.75)",
        //position: 'absolute',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%'
    },
    inputInput: {
        fontSize: 14,
        padding: "12px 0px",
        //paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        width: '100%'
    },
    listingDiv: {
        marginTop: 24
    },
    subTitleSec: {
        marginBottom: 8,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    subTitleTxt: {
        fontSize: 12,
        fontWeight: 600,
        color: "rgba(11, 19, 35, 0.5)"
    },
    vendorDiv: {
        padding: 16,
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        //transition:'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        marginBottom: 12,
        borderRadius: 8,
        cursor: "pointer",
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'cente',
        justifyContent: 'space-between'
    },
    nameDiv: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 16
    },
    highlight: {
        color: "#1860f0",
        padding: 0
    },
    balanceDiv: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 16
    },
    listDriverBalancePositive: {
        fontWeight: 600,
        color: "#379953"
    },
    listDriverBalanceNegative: {
        fontWeight: 600,
        color: "#ff0000"
    },
    vendorBalance: {
        fontSize: 16,
        fontWeight: 600,
        color: '#0b1323',
    },
    divAllocatedAmount: {
        padding: '8px 16px 8px 16px',
        borderRadius: 4,
        backgroundColor: '#c6d4ff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
    },
    divAmount: {
        fontSize: 18,
        fontWeight: 600,
        letterSpacing: 'normal',
        color: '#0b1323'
    },
    divAmountError: {
        fontSize: 18,
        fontWeight: 600,
        letterSpacing: 'normal',
        color: '#ff0000'
    },
    amountText: {
        fontSize: 16,
        color: '#0033cc'
    },
    amountTextError: {
        fontSize: 16,
        color: '#ff0000'
    },
    errorV2: {
        color: '#ff0000',
        marginTop: 8,
        fontSize: 12
    },
    mbV1: {
        marginBottom: 16,
    },
    divAllocatedAmountError: {
        padding: '8px 16px 8px 16px',
        borderRadius: 4,
        backgroundColor: '#ffe3e3',
        display: 'flex',
        justifyContent: 'space-between'
    },
    addBankButton: {
        color: '#f6f6f8',
        padding: '12px 16px 12px 16px',
        borderRadius: 4,
        border: 'solid 1px #0033cc',
        backgroundColor: '#0033cc',
        fontWeight: 500,
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#0033cc'
        }
    },
    addIcon: {
        color: 'white',
        marginRight: 8
    },
    mtV2: {
        marginTop: 24
    },
    hrV1: {
        borderTop: '1px dashed #dcdcdc',
        marginTop: 24,
        marginBottom: 0
    },
    payOnlineTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    titleV1: {
        fontSize: 12,
        fontWeight: 600,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    divListing: {
        '&:nth-child(1)': {
            marginTop: 8
        },
        '& >*': {
            marginTop: 12
        }
    },
    dotV3: {
        color: '#c4c4c4',
        marginLeft: 4,
        marginRight: 4,
        fontSize: 7
    },
    cardV1: {
        borderRadius: 8,
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ffffff'
    },
    cardContentV1: {
        padding: 16,
        paddingBottom: '16px !important'
    },
    gridTextV1: {
        fontSize: 16,
        fontWeight: 600,
        color: '#0b1323'
    },
    gridTextV2: {
        fontSize: 12,
        fontWeight: 'normal',
        marginTop: 2
    },
    bankDetailsDiv: {
        padding: 16,
        borderRadius: 8,
        backgroundColor: " #fff",
        marginTop: 8
    },
    bankValueDiv: {
        display: 'flex',
        flexDirection: 'column',
        fontSize: 16
    },
    valueTxt: {
        textTransform: 'capitalize',
        fontWeight: 600
    },
    valueTxtUPI: {
        fontWeight: 600
    },
    alignEnd: {
        textAlign: 'end'
    },
    verifiedAccount: {
        fontSize: 12,
        color: "rgba(21, 128, 38, 0.6)"
    },
    unVerifiedAccount: {
        fontSize: 12,
        color: "#e93333"
    },
    valueTxt1: {
        textTransform: 'capitalize',
    },
    changeButton: {
        padding: "8px 16px",
        borderRadius: 8,
        border: "solid 1px #f1f1f1",
        backgroundColor: " #0033cc",
        fontSize: 12,
        fontWeight: 600,
        color: "#fff",
        textTransform: 'capitalize',
        "&:hover": {
            backgroundColor: " #0033cc",
        }
    },
    saveButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#dadada !important',
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        color: '#5e636c !important',
        textTransform: 'none',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        marginLeft: '16px !important',
        '&:hover': {
            backgroundColor: '#dadada'
        }
    },

}));